import React from "react";
import './SalesPackageOptionStyles.scss';
import {SimpleTooltip} from "../SimpleTooltip";
import {premiumFormat} from "../../utils/format";
import {strings} from "../../strings/strings";
import checkRoundActive from "../../images/check-round-active.svg";
import checkRoundInactive from "../../images/check-round-inactive.svg";
import {translit} from "../../utils/utils";


export interface SalesPackageOption {
    name: string;
    tooltip?: React.ReactElement;
    tooltipPlacement?: "top" | "bottom" | "left" | "right";
    covered: boolean;
    price?: number;
}

export const SalesPackageOption = ({name, tooltip, tooltipPlacement, covered, price}: SalesPackageOption) => {
    const optionBlock = <div className='sales-package-option__block'>
		<span className='sales-package-option__icon'>
						{covered ? (
                            <img src={checkRoundActive} alt=''/>
                        ) : (
                            <img src={checkRoundInactive} alt=''/>
                        )}
					</span>

        <span className={'sales-package-option__name'}>{name}</span>
    </div>;

    return (
        <span className='sales-package-option'>
			{tooltip && (
                <SimpleTooltip id={'sales' + translit(name)} title={tooltip} placement={tooltipPlacement}>
                    {optionBlock}
                </SimpleTooltip>
            )}

            {!tooltip && (
                optionBlock
            )}

            {price ? <div
                className="sales-package-option__price">{`${premiumFormat(price)} ${strings.currencyUAH}`}</div> : <></>}
		</span>
    )

};
